import React, { useEffect, useState } from "react";
import { useSelector ,useDispatch} from "react-redux";
import IsLoadingHOC from "../../common/IsLoadingHOC";
import { authAxios } from "../../config/config";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { formatBoldText ,BlogsHelper} from "../../helper/helper";
import { setrefetch } from "../../Redux/Reducers/authSlice";

const LoanForm = ({ setLoading }) => {
  const userName = useSelector((state) => state.auth.user.fname);
  const location = useLocation();
  const ids = location?.state?.id;
  const [formValues, setFormValues] = useState({
    Entrepreneurs_Full_Name: "",
    Preferred_Personal_Pronoun: "",
    title: "story title",
    Business_Name: "",
    Location_City: "",
    Years_in_Business: "",
    Prior_to_Starting_a_Business: "",
    Why_Become_an_Entrepreneur: "",
    Business_Start_Date_and_Reason: "",
    Business_Description: "",
    Entrepreneurship_Journey: "",
    Community_Role_in_Business_Success: "",
    Giving_Back_to_Community: "",
    Experience_with_WeBC: "",
    WeBC_Services_Support: "",
    Future_WeBC_Services_Interest: "",
    Business_Five_Year_Goal: "",
    Next_Step_in_Entrepreneurship: "",
    Advice_for_Other_Women_Entrepreneurs: "",
    Additional_Info: "",
  });

  const [storyDetail, setstoryDetail] = useState([]);
  const dispatch = useDispatch()

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    const endpoint = editable ? 'stories/edit_multiform' : 'stories/submit_multiform';
    
    const payload = {
      formType: "Loan",
      selectedSet: "set2",
      ...(editable && { _id: storyId }), 
      answers: formValues,
    };
  
    try {
      const response = await authAxios().post(endpoint, payload);
      const resData = response?.data;
 if(resData?.status === 1){
      setstoryDetail(resData.data);
      dispatch(setrefetch("story"))
      toast.success(resData?.message);
      
      sessionStorage.removeItem("editable")
    }
    else{
      toast?.error(resData?.message)
    }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  
  const storyId = sessionStorage.getItem("story_id");
  const editable = sessionStorage.getItem("editable");

  const fetchstory = async () => {
    setLoading(true);
    await authAxios()
      .post(`/stories/get_single_multi_storie`, { _id: storyId })
      .then((response) => {
        setLoading(false);
        const data = response?.data?.data;

        if (data && data.answers && data.answers.length > 0) {
          const answers = data.answers[0];
    
          setFormValues(prevValues => ({
            ...prevValues,
            ...answers,
          }));
        }
          setstoryDetail(data)
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };
  useEffect(() => {
    if(storyId ){
      fetchstory();
    }
  }, [storyId]);


  useEffect(() => {
    sessionStorage.removeItem("editable");
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
      title: formValues.Entrepreneurs_Full_Name,
    });
  };

  return (
    <>
      <div className="h-full flex flex-col justify-between">
        <div>
          <style>
            {`
              .custom-scrollbar::-webkit-scrollbar {
                width: 10px;
              }
              .custom-scrollbar::-webkit-scrollbar-thumb {
                background: #fce7da;
                border-radius: 10px;
              }
            `}
          </style>

          <div
            className={`py-[20px] overflow-auto h-[calc(100vh-100px)] pb-[35px] custom-scrollbar`}
          >
            <div className="bg-[#FFE6D9] border-[2px] border-[#EE635B] p-[15px] rounded-[10px] flex items-center gap-5 max-w-[885px] w-full mx-auto mb-5">
              <div>
                <img
                  src="./assets/images/story-c.png"
                  alt="image"
                  className="w-[65px] aspect-square"
                  onClick={() => sessionStorage.removeItem("formType")}
                  style={{cursor:'pointer'}}
                />
              </div>
              <p className="text-[#2C2C2C] text-[20px] font-semibold">
                Write your story
              </p>
            </div>

            <div className="max-w-[885px] w-full mx-auto">
              <div className="bg-[#FFE6D9] rounded-t-[10px] min-h-[88px] text-center p-[20px] flex items-center justify-center border-b-[2px] border-b-[#fff]">
                <h1 className="text-[#000] lg:text-[40px] font-[600] text-[25px]">
                  Welcome <span className="capitalize">{userName}!</span>
                </h1>
              </div>

              <form
                onSubmit={handleSubmit}
                className="bg-[#FFE6D9] lg:p-[40px] p-[15px] lg:pb-[10px] rounded-b-[10px]"
              >
                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="entrepreneurName"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      Entrepreneur's Full Name
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="Entrepreneurs_Full_Name"
                      value={formValues.Entrepreneurs_Full_Name}
                      onChange={handleInputChange}
                      className={`min-h-[50px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                       disabled={storyDetail?.story && !editable}
                    />
                  </div>
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="location"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      Location(City) <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="Location_City"
                      value={formValues.Location_City}
                      onChange={handleInputChange}
                      className={`min-h-[50px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                       disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                <h3 className="mb-4 font-semibold text-gray-900 dark:text-white">
                  Preferred Personal Pronoun
                </h3>
                <ul className="items-center w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg sm:flex dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                  <li className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r dark:border-gray-600">
                    <div className="flex items-center ps-3">
                      <input
                        id="pronoun-she"
                        type="radio"
                        value="She/Her"
                        name="Preferred_Personal_Pronoun"
                        checked={formValues?.Preferred_Personal_Pronoun === "She/Her"}
                         disabled={storyDetail?.story && !editable}
                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                        onChange={handleInputChange}
                      />
                      <label
                        htmlFor="pronoun-she"
                        className="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >
                        She/Her
                      </label>
                    </div>
                  </li>
                  <li className="w-full border-b border-gray-200 sm:border-b-0 sm:border-r dark:border-gray-600">
                    <div className="flex items-center ps-3">
                      <input
                        id="pronoun-he"
                        type="radio"
                        value="He/Him"
                        name="Preferred_Personal_Pronoun"
                        checked={formValues?.Preferred_Personal_Pronoun === "He/Him"}
                         disabled={storyDetail?.story && !editable}
                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                        onChange={handleInputChange}
                      />
                      <label
                        htmlFor="pronoun-he"
                        className="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >
                        He/Him
                      </label>
                    </div>
                  </li>
                  <li className="w-full dark:border-gray-600">
                    <div className="flex items-center ps-3">
                      <input
                        id="pronoun-they"
                        type="radio"
                        value="They/Them"
                        name="Preferred_Personal_Pronoun"
                        checked={formValues?.Preferred_Personal_Pronoun === "They/Them"}
                         disabled={storyDetail?.story && !editable}

                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                        onChange={handleInputChange}
                      />
                      <label
                        htmlFor="pronoun-they"
                        className="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >
                        They/Them
                      </label>
                    </div>
                  </li>
                
                </ul>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="businessName"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      Business Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="Business_Name"
                      value={formValues.Business_Name}
                      onChange={handleInputChange}
                      className={`min-h-[50px] rounded-[8px] p-[15px]  ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                       disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="entrepreneurIntroduction"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      Years in Business <span className="text-red-500">*</span>
                    </label>
                    <input
                      name="Years_in_Business"
                      value={formValues.Years_in_Business}
                      onChange={handleInputChange}
                      className={`min-h-[50px] rounded-[8px] p-[15px]  ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      // className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${storyDetail ? 'bg-white' : ''}`}
                      required
                       disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="entrepreneurIntroduction"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      What were you doing prior to starting a business?{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Prior_to_Starting_a_Business"
                      value={formValues.Prior_to_Starting_a_Business}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                       disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="businessIntroduction"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      What made you want to be an entrepreneur?{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Why_Become_an_Entrepreneur"
                      value={formValues.Why_Become_an_Entrepreneur}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                       disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="motivation"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      When did you start your business and why?
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Business_Start_Date_and_Reason"
                      value={formValues.Business_Start_Date_and_Reason}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                       disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="challenges"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      What exactly does your business do?
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Business_Description"
                      value={formValues.Business_Description}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                       disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="challenges"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      Tell us about your entrepreneurship journey. What’s the
                      biggest lesson you have learned on your entrepreneurial
                      journey?
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Entrepreneurship_Journey"
                      value={formValues.Entrepreneurship_Journey}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                       disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="challenges"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      Has your community played a role in your business’
                      success? If so, how?
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Community_Role_in_Business_Success"
                      value={formValues.Community_Role_in_Business_Success}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                       disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="challenges"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      Do you give back to your community through your business
                      (e.g. donations, volunteering)?
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Giving_Back_to_Community"
                      value={formValues.Giving_Back_to_Community}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                       disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="challenges"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      Tell us about your experience with WeBC. What has your
                      WeBC loan enabled you to do in your business (e.g. hire
                      staff, grow inventory, land a new contract)?
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Experience_with_WeBC"
                      value={formValues.Experience_with_WeBC}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                       disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="challenges"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      How have WeBC services supported your business (e.g.
                      Business Advising, Mentoring or Training) and how have
                      these services helped you?
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="WeBC_Services_Support"
                      value={formValues.WeBC_Services_Support}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                       disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="challenges"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      If you haven’t yet, what WeBC services would you be
                      interested in taking advantage of in the future?
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Future_WeBC_Services_Interest"
                      value={formValues.Future_WeBC_Services_Interest}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                       disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="futureGoals"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      Where do you see your business in five years?
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Business_Five_Year_Goal"
                      value={formValues.Business_Five_Year_Goal}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                       disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="quotes"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      What is your next step in your entrepreneurship journey?
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Next_Step_in_Entrepreneurship"
                      value={formValues.Next_Step_in_Entrepreneurship}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                       disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="referralSource"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      If you could give one piece of advice to another woman
                      entrepreneur based on what you have learned/experienced,
                      what would it be?
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Advice_for_Other_Women_Entrepreneurs"
                      value={formValues.Advice_for_Other_Women_Entrepreneurs}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                       disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="yearJoined"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      Is there anything else you’d like to share (e.g.
                      milestones, awards, people who have helped you)?
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Additional_Info"
                      value={formValues.Additional_Info}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                       disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>
                {storyDetail?.story ? (
                  <>
                  <div className="flex flex-col lg:flex-row gap-3 mb-3 bg-white p-5 rounded-[10px]">
                    <div className="w-full flex flex-col gap-y-[10px]">
                     
                      <div>
                        <p>{BlogsHelper(storyDetail?.story) || ""}</p>
                      </div>
                    </div>
                  </div>
                  {editable && 
                  <div className="flex justify-center py-3">
                    <button
                  type="submit"
                  className="bg-[#EE635B] text-[#FFFFFF] text-[16px] font-[600] rounded-[8px] py-[15px] px-[30px] min-w-[130px]"
                >
                   Regenerate
                </button>
                </div>}
                  </>
                ) : (
                  <div className="flex justify-center py-3">
                    <button
                      type="submit"
                      className="bg-[#EE635B] text-[#FFFFFF] text-[16px] font-[600] rounded-[8px] py-[15px] px-[30px] min-w-[130px]"
                    >
                      Submit
                    </button>
                  </div>
                )}

                {/* <div className="flex justify-center py-3">
                  <button
                    type="submit"
                    className="bg-[#EE635B] text-[#FFFFFF] text-[16px] font-[600] rounded-[8px] py-[15px] px-[30px] min-w-[130px]"
                  >
                    Submit
                  </button>
                </div> */}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IsLoadingHOC(LoanForm);
